/*
 * ROST ZAUN - Zaunkonfigurator für Shopify
 *
 * Rechnet die komplette Stückliste (Matten, Pfosten, Ecken, Tore, Sichtschutz)
 * und legt das Ergebnis als echte Shopify-Warenkorbpositionen ab.
 *
 * Preisquelle ist AUSSCHLIESSLICH Shopify: window.ROST_DATEN.varianten wird vom
 * Liquid aus den importierten Produkten gerendert (SKU -> Varianten-ID + Preis in
 * Cent). Ändert Kevin einen Preis im Shopify-Adminbereich, rechnet der Konfigurator
 * sofort damit. Es gibt bewusst KEINE zweite Preisliste im Code, die veralten könnte.
 *
 * Alle Beträge intern in Cent (Hauskonvention), Ausgabe geteilt durch 100.
 *
 * Relaunch 19.09.2026 - NUR Anzeige, berechne() und die SKU-Bildner sind unverändert
 * (gegengerechnet mit sechs festen Konfigurationen: Positionen, Mengen und Warenwert
 * vorher und nachher gleich):
 *  - Endbetrag passend zur Lieferwahl: Warenwert + Lieferung = Gesamt bzw. Abholung 0 €,
 *    in Stückliste, festem Fuß und mobiler Preisleiste (endbetrag()).
 *  - Lieferkosten und Freigrenze kommen als data-Attribute aus konfigurator.liquid (dort aus
 *    settings.lieferkosten, wortgleich zu cart.liquid). Die Zahlen unten sind nur Rückfallwerte.
 *  - Hinweis „Mit Sichtschutz empfehlen wir 8/6/8“ mit live gerechnetem Mehrpreis. KEINE
 *    Höhengrenze nennen, 1,63 m ist keine Windlastgrenze (Kevin-Go 30.08.2026).
 *  - Gratis-Hinweis nur, wenn Matten in der Stückliste stehen (Bericht Recht C4).
 *  - Sichtbar heißt es „Befestigung“, im Code bleibt es montage (SKU-Kürzel EIN/AUF).
 *  - Geldformat einheitlich „1.234,56 €“ über Intl de-DE, wie warenkorb.js und schnellauswahl.js.
 */
(function () {
  "use strict";

  var DATEN = window.ROST_DATEN || { varianten: {}, bilder: {} };
  var V = DATEN.varianten || {};

  var HOEHEN = [630, 830, 1030, 1230, 1430, 1630, 1830, 2030];
  var FARB_KUERZEL = { "Anthrazit": "ANT", "Moosgrün": "MOO", "Verzinkt": "VER", "Fenstergrau": "FEN" };
  var MONTAGE_KUERZEL = { "Einbetonieren": "EIN", "Aufdübeln": "AUF" };
  var STAERKE_KUERZEL = { "6/5/6": "656", "8/6/8": "868" };
  var FARB_SLUG = { "Anthrazit": "anthrazit", "Moosgrün": "moosgruen", "Verzinkt": "verzinkt", "Fenstergrau": "fenstergrau" };

  // Die kleinste lieferbare Torhöhe ist 800 mm. Bei 630 mm Zaunhöhe wäre jedes Tor
  // höher als der Zaun, deshalb gibt es dort keine Tore (Kevin-Vorgabe 26.07.2026).
  var MIN_HOEHE_TORE = 830;
  var ZAUN_ZU_TOR_HOEHE = { 630: 800, 830: 800, 1030: 1000, 1230: 1200, 1430: 1400, 1630: 1600, 1830: 1800, 2030: 2000 };
  var TOR_BREITEN = {
    basic_single: [1000, 1200], basic_double: [3000],
    multi_single: [1000, 1200, 1500], multi_double: [3000, 3500, 4000, 4500, 5000, 5500, 6000]
  };
  // Sichtschutz: Streifenreihen je Zaunhöhe. Eine Reihe entspricht einer
  // Maschenreihe der Doppelstabmatte (200 mm Teilung, Höhe geteilt durch 200),
  // je Reihe wird ein 2,5-m-Streifen pro Matte eingeflochten.
  // Reihenzahlen von Kevin bestätigt am 09.08.2026.
  var SICHT_REIHEN = { 630: 3, 830: 4, 1030: 5, 1230: 6, 1430: 7, 1630: 8, 1830: 9, 2030: 10 };
  var SICHT_FORMEN = [
    { name: "Genarbt", kuerzel: "GEN", staerke: "1,1 mm", beschreibung: "matte, fein genarbte Oberfläche" },
    { name: "Gerillt", kuerzel: "GER", staerke: "1,35 mm", beschreibung: "längs gerillt, kräftigeres Material" }
  ];
  // Lieferkosten und Freigrenze: Quelle sind die data-Attribute der Section (aus den
  // Theme-Einstellungen, dieselbe Umrechnung wie im Warenkorb). Die Zahlen hier greifen nur,
  // wenn das Attribut fehlt oder unlesbar ist. Das Skript lädt mit defer, das DOM steht also.
  var QUELLE = document.querySelector("[data-konfigurator]");
  function centAus(attribut, ersatz) {
    var roh = QUELLE && QUELLE.getAttribute ? QUELLE.getAttribute(attribut) : null;
    var n = parseInt(roh, 10);
    return isFinite(n) && n >= 0 && roh !== null && roh !== "" ? n : ersatz;
  }
  var LIEFERKOSTEN_CENT = centAus("data-lieferung-cent", 9900);
  var VERSANDFREI_AB_CENT = centAus("data-frei-ab-cent", 200000); // ab 2.000 € Warenwert kostenlos (Kevin 28.08.2026)

  var euro = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" });
  var zahl = new Intl.NumberFormat("de-DE");
  var geld = function (cent) { return euro.format(cent / 100); };
  // „99 €“ statt „99,00 €“ für Sätze; krumme Beträge behalten die volle Schreibweise.
  var rundGeld = function (cent) { return cent % 100 === 0 ? zahl.format(cent / 100) + " €" : geld(cent); };

  // Endbetrag passend zur Lieferwahl. Rechnet nichts Neues: versandCent kommt aus berechne().
  function endbetrag(r, lieferart) {
    var abholung = lieferart !== "Lieferung";
    return {
      versandCent: r.versandCent,
      gesamtCent: r.warenwertCent + r.versandCent,
      versandText: abholung ? "Abholung in Bremerhaven"
        : (r.versandCent === 0 ? "Lieferung (ab " + rundGeld(VERSANDFREI_AB_CENT) + " Warenwert kostenlos)" : "Lieferung deutschlandweit"),
      leisteText: abholung ? "Gesamt inkl. MwSt., Abholung 0 €"
        : (r.versandCent === 0 ? "Gesamt inkl. MwSt., Lieferung kostenlos" : "Gesamt inkl. MwSt. und " + rundGeld(r.versandCent) + " Lieferung")
    };
  }

  /* ---------- SKU-Bildner. Muss exakt zu produkte_bauen.py passen. ---------- */
  function skuBauteil(praefix, staerke, hoehe, farbe, montage) {
    return praefix + "-" + STAERKE_KUERZEL[staerke] + "-" + hoehe + "-" + FARB_KUERZEL[farbe] + "-" + MONTAGE_KUERZEL[montage];
  }
  function skuAbdeckleiste(hoehe, istEck) { return "AL-" + hoehe + "-" + (istEck ? "ECK" : "STD"); }
  function skuTor(serie, typ, breite, torHoehe, farbe) {
    return "TOR-" + (serie === "Multi" ? "MUL" : "BAS") + "-" + (typ === "single" ? "EIN" : "DOP") +
      "-" + breite + "-" + torHoehe + "-" + FARB_KUERZEL[farbe];
  }
  function variante(sku) { return V[sku] || null; }

  /* ---------- Sichtschutz-Menge automatisch berechnen ---------- */
  // Die verfügbaren Gebinde (Rollen, Einzelstreifen) kommen aus den
  // Shopify-Varianten des Produkts "sichtschutzstreifen" (DATEN.sicht),
  // die Meterzahl steckt im Gebinde-Namen der Variante. Nichts ist hart codiert.
  function meterAusGebinde(label) {
    var treffer = String(label || "").replace(",", ".").match(/(\d+(\.\d+)?)/);
    return treffer ? Number(treffer[1]) : 0;
  }
  function sichtGebinde(form, farbe) {
    var f = SICHT_FORMEN.filter(function (x) { return x.name === form; })[0] || SICHT_FORMEN[0];
    var praefix = "SS-" + f.kuerzel + "-" + FARB_KUERZEL[farbe] + "-";
    return (DATEN.sicht || []).filter(function (e) {
      return e.sku && e.sku.indexOf(praefix) === 0 && V[e.sku];
    }).map(function (e) {
      return { sku: e.sku, label: e.gebinde, meter: meterAusGebinde(e.gebinde), preis: V[e.sku].preis };
    }).filter(function (g) { return g.meter > 0; });
  }
  // Günstigste Kombination aus Gebinden, die den Bedarf mindestens abdeckt.
  // Gerechnet wird in 0,5-m-Schritten, damit auch 2,5-m-Streifen exakt passen.
  function guenstigsteKombi(bedarfMeter, gebinde) {
    if (!gebinde.length || !(bedarfMeter > 0)) return null;
    var ziel = Math.ceil(bedarfMeter * 2);
    var dp = new Array(ziel + 1);
    var wahl = new Array(ziel + 1);
    dp[0] = 0;
    for (var i = 1; i <= ziel; i++) {
      dp[i] = Infinity;
      for (var g = 0; g < gebinde.length; g++) {
        var schritt = Math.round(gebinde[g].meter * 2);
        if (schritt <= 0) continue;
        var kosten = dp[Math.max(0, i - schritt)] + gebinde[g].preis;
        if (kosten < dp[i]) { dp[i] = kosten; wahl[i] = g; }
      }
    }
    if (!isFinite(dp[ziel])) return null;
    var mengen = {};
    for (var rest = ziel; rest > 0;) {
      var idx = wahl[rest];
      mengen[idx] = (mengen[idx] || 0) + 1;
      rest = Math.max(0, rest - Math.round(gebinde[idx].meter * 2));
    }
    return Object.keys(mengen).map(function (idx2) {
      var g2 = gebinde[idx2];
      return { sku: g2.sku, label: g2.label, meter: g2.meter, menge: mengen[idx2], cent: g2.preis * mengen[idx2] };
    }).sort(function (a, b) { return b.meter - a.meter; });
  }
  function sichtKalkulation(k, matten) {
    var reihen = SICHT_REIHEN[k.hoehe];
    if (!reihen || !(matten > 0)) return null;
    var bedarfMeter = matten * 2.5 * reihen;
    var kombi = guenstigsteKombi(bedarfMeter, sichtGebinde(k.sichtForm, k.sichtFarbe));
    if (!kombi) return null;
    var summeCent = kombi.reduce(function (s, t) { return s + t.cent; }, 0);
    var text = kombi.map(function (t) { return t.menge + "× " + t.label; }).join(" + ");
    return { reihen: reihen, bedarfMeter: bedarfMeter, teile: kombi, summeCent: summeCent, text: text };
  }

  /* ---------- Kalkulation ---------- */
  function berechne(k) {
    var fehler = [];
    var positionen = [];

    function nimm(sku, menge, titel, details) {
      var v = variante(sku);
      if (!v) { fehler.push("Für „" + titel + "“ liegt in diesem Shop kein Preis vor (" + sku + ")."); return; }
      positionen.push({
        sku: sku, id: v.id, menge: menge, titel: titel, details: details || [],
        einzelCent: v.preis, summeCent: v.preis * menge
      });
    }

    if (!(k.laenge > 0) || k.laenge > 500) return { ok: false, meldung: "Bitte eine Zaunlänge zwischen 0 und 500 Metern angeben." };
    if (k.farbe === "Verzinkt" && k.montage === "Aufdübeln") return { ok: false, meldung: "Verzinkt ist nur zum Einbetonieren verfügbar." };
    if (k.hoehe < MIN_HOEHE_TORE && (k.torEinzel + k.torDoppel) > 0) return { ok: false, meldung: "Bei 630 mm Zaunhöhe bieten wir keine Tore an, weil die kleinste lieferbare Torhöhe 800 mm beträgt." };
    if (k.farbe === "Verzinkt" && k.torSerie === "Basic" && (k.torEinzel + k.torDoppel) > 0) return { ok: false, meldung: "Basic-Tore gibt es nicht in Verzinkt." };

    // Torbreite plus 6 cm Anschluss wird von der Zaunlänge abgezogen
    var torBreiteGesamt = k.torEinzel * (k.torEinzelBreite / 1000 + 0.06) + k.torDoppel * (k.torDoppelBreite / 1000 + 0.06);
    var effektiveLaenge = Math.max(0, k.laenge - torBreiteGesamt);
    var matten = effektiveLaenge > 0 ? Math.ceil(effektiveLaenge / 2.5) : 0;
    var pfostenGesamt = matten > 0 ? matten + 1 : 0;
    var eckpfosten = Math.max(0, Math.min(Math.floor(k.ecken), pfostenGesamt));
    var pfostenNormal = Math.max(0, pfostenGesamt - eckpfosten);

    if (matten === 0 && (k.torEinzel + k.torDoppel) === 0) {
      return { ok: false, meldung: "Die Konfiguration enthält weder Zaunfelder noch Tore." };
    }

    if (matten > 0) {
      var pfostenHinweis = k.montage === "Einbetonieren"
        ? "zum Einbetonieren, Pfosten 60 cm länger als die Zaunhöhe (Teil im Fundament)"
        : "zum Aufdübeln, mit Fußplatte für festen Untergrund";
      // Einzelartikel-Logik (Kevin 08.08.2026): Matte, Zaunpfosten und Eckpfosten
      // sind eigene Positionen mit echter Stückzahl. Die Preise dafür sind in
      // Shopify entsprechend aufgeteilt (Matte ohne Pfosten, Eckpfosten voll) -
      // die Gesamtsumme entspricht exakt der früheren Paket-Darstellung.
      nimm(skuBauteil("ZF", k.staerke, k.hoehe, k.farbe, k.montage), matten,
        "Doppelstabmatte, 2,50 m breit",
        ["Höhe " + k.hoehe + " mm", "Drahtstärke " + k.staerke + " mm", "Farbe " + k.farbe]);
      if (pfostenNormal > 0) {
        nimm(skuBauteil("AP", k.staerke, k.hoehe, k.farbe, k.montage), pfostenNormal,
          "Zaunpfosten",
          ["Höhe " + k.hoehe + " mm", "Farbe " + k.farbe, "mit " + k.pfostenart,
           pfostenHinweis, "inklusive Befestigungsmaterial und Pfostenkappe"]);
      }
      if (eckpfosten > 0) {
        nimm(skuBauteil("EP", k.staerke, k.hoehe, k.farbe, k.montage), eckpfosten,
          "Eckpfosten",
          ["Höhe " + k.hoehe + " mm", "Farbe " + k.farbe, "mit " + k.pfostenart,
           pfostenHinweis, "Befestigung über Eck, ersetzt einen normalen Zaunpfosten"]);
      }
      if (k.pfostenart === "Abdeckleiste") {
        if (pfostenNormal > 0) nimm(skuAbdeckleiste(k.hoehe, false), pfostenNormal,
          "Aufpreis Abdeckleiste, normale Pfosten", ["statt Abdeckplättchen, höherwertige Ausführung"]);
        if (eckpfosten > 0) nimm(skuAbdeckleiste(k.hoehe, true), eckpfosten,
          "Aufpreis Abdeckleiste, Eckpfosten", ["statt Abdeckplättchen, höherwertige Ausführung"]);
      }
    }

    var torHoehe = ZAUN_ZU_TOR_HOEHE[k.hoehe];
    if (k.torEinzel > 0) {
      nimm(skuTor(k.torSerie, "single", k.torEinzelBreite, torHoehe, k.farbe), k.torEinzel,
        "Einzeltor " + (k.torEinzelBreite / 10) + " cm, Serie " + k.torSerie,
        ["Durchgangsbreite " + (k.torEinzelBreite / 10) + " cm", "Torhöhe " + torHoehe + " mm (Zaunhöhe " + k.hoehe + " mm)",
         "Farbe " + k.farbe, "komplett mit Torpfosten, Schloss, Drücker und Zubehör"]);
    }
    if (k.torDoppel > 0) {
      nimm(skuTor(k.torSerie, "double", k.torDoppelBreite, torHoehe, k.farbe), k.torDoppel,
        "Doppeltor " + (k.torDoppelBreite / 10) + " cm, Serie " + k.torSerie,
        ["Durchgangsbreite " + (k.torDoppelBreite / 10) + " cm, zweiflügelig", "Torhöhe " + torHoehe + " mm (Zaunhöhe " + k.hoehe + " mm)",
         "Farbe " + k.farbe, "komplett mit Torpfosten, Schloss, Drücker und Zubehör"]);
    }

    // Sichtschutz wird immer mitgerechnet (für die Preisanzeige an der Checkbox),
    // in die Stückliste kommt er nur, wenn der Kunde ihn angehakt hat.
    var sicht = sichtKalkulation(k, matten);
    if (k.sichtAuto && sicht) {
      var form = SICHT_FORMEN.filter(function (x) { return x.name === k.sichtForm; })[0] || SICHT_FORMEN[0];
      sicht.teile.forEach(function (t) {
        nimm(t.sku, t.menge,
          "Sichtschutzstreifen " + t.label,
          ["Farbe " + k.sichtFarbe + ", Oberfläche " + form.name, "Polypropylen, Materialstärke " + form.staerke,
           "für den gesamten Zaun: " + zahl.format(sicht.bedarfMeter) + " m in " + sicht.reihen + " Reihen"]);
      });
    } else if (k.sichtAuto && matten > 0) {
      // Angehakter Sichtschutz darf nie stillschweigend fehlen (Fail-Loud wie bei
      // allen anderen Positionen): ohne Gebinde-Daten wird die Bestellung gestoppt.
      fehler.push("Für den Sichtschutz liegen in diesem Shop gerade keine Preise vor.");
    }

    var warenwertCent = positionen.reduce(function (s, p) { return s + p.summeCent; }, 0);
    return {
      ok: fehler.length === 0, meldung: fehler.join(" "),
      // Zaunfluss 08.10.2026: A3d-Felder sind bereits vollständig vorhanden.
      positionen: positionen, matten: matten, pfostenNormal: pfostenNormal, eckpfosten: eckpfosten,
      pfostenGesamt: pfostenGesamt, effektiveLaenge: effektiveLaenge, torBreiteGesamt: torBreiteGesamt,
      warenwertCent: warenwertCent, sicht: sicht,
      versandCent: k.lieferart === "Lieferung" && warenwertCent < VERSANDFREI_AB_CENT ? LIEFERKOSTEN_CENT : 0
    };
  }

  /* ---------- Oberfläche ---------- */
  function start() {
    var wurzel = document.querySelector("[data-konfigurator]");
    if (!wurzel) return;

    var feld = function (name) { return wurzel.querySelector('[data-feld="' + name + '"]'); };
    var zahlWert = function (name, ersatz) {
      var e = feld(name);
      if (!e) return ersatz;
      var n = Number(e.value);
      return isFinite(n) ? n : ersatz;
    };

    /* Umbau 08.10.2026: Länge aus dem Textfeld lesen. „22,5“ → 22,5 · „20,“ → 20 · „1.000“ → 1000 · „1.250,5“ → 1250,5 ·
       leer oder negativ → 0 (dann Hinweis). Ein einzelner Punkt ohne drei Ziffern danach bleibt Dezimalpunkt („22.5“). */
    function laengeLesen(text) {
      var t = String(text == null ? "" : text).replace(/\s/g, "");
      if (/^\d{1,3}(\.\d{3})+(,\d*)?$/.test(t)) t = t.replace(/\./g, "");
      var n = Number(t.replace(",", "."));
      return isFinite(n) && n > 0 ? n : 0;
    }
    var zustand = {
      laenge: 20, hoehe: 1230, staerke: "6/5/6", farbe: "Anthrazit", montage: "Einbetonieren",
      ecken: 0, pfostenart: "Abdeckplättchen", torSerie: "Basic",
      torEinzel: 0, torEinzelBreite: 1000, torDoppel: 0, torDoppelBreite: 3000,
      lieferart: "Lieferung", sichtFarbe: "Anthrazit", sichtForm: "Genarbt", sichtAuto: false,
      // Ja/Nein-Fragen (Kevin 15.08.2026): Tor- und Sichtschutz-Details öffnen
      // sich erst nach "ja". sichtJa steuert sichtAuto, torJa die Tor-Stückzahlen.
      torJa: "nein", sichtJa: "nein"
    };

    // Die mobile Preisleiste erscheint erst, wenn der Kunde im Konfigurator
    // etwas eingegeben hat und der Abschnitt im Bild ist.
    var interagiert = false;
    var abschnittSichtbar = true;

    // Auswahlknöpfe (Drahtstärke, Farbe, Montage, Pfosten, Tor-Serie, Lieferart, Sichtschutz)
    wurzel.addEventListener("click", function (ereignis) {
      var knopf = ereignis.target.closest("[data-wahl]");
      if (!knopf || knopf.disabled) return;
      ereignis.preventDefault();
      var schluessel = knopf.getAttribute("data-wahl");
      var wert = knopf.getAttribute("data-wert");
      interagiert = true;
      zustand[schluessel] = isNaN(Number(wert)) || wert === "" ? wert : Number(wert);

      if (schluessel === "farbe" && wert === "Verzinkt") {
        if (zustand.montage === "Aufdübeln") zustand.montage = "Einbetonieren";
        if (zustand.torSerie === "Basic") zustand.torSerie = "Multi";
      }
      if (schluessel === "torJa") {
        if (wert === "ja") {
          // Beim Öffnen direkt ein Einzeltor vorschlagen, damit der Preis sofort
          // reagiert. Der Kunde kann die Stückzahlen frei ändern.
          if (zustand.torEinzel + zustand.torDoppel === 0) zustand.torEinzel = 1;
        } else {
          zustand.torEinzel = 0;
          zustand.torDoppel = 0;
        }
        var torEinzelFeld = feld("torEinzel");
        if (torEinzelFeld) torEinzelFeld.value = zustand.torEinzel || "";
        var torDoppelFeld = feld("torDoppel");
        if (torDoppelFeld) torDoppelFeld.value = zustand.torDoppel || "";
      }
      if (schluessel === "sichtJa") zustand.sichtAuto = wert === "ja";
      knopfgruppeAktualisieren();
      zeichnen();
    });

    wurzel.addEventListener("input", function (ereignis) {
      var e = ereignis.target;
      var name = e.getAttribute("data-feld");
      if (!name) return;
      interagiert = true;
      if (name === "laenge" || name === "laengeExakt") {
        zustand.laenge = Math.max(0, laengeLesen(e.value));
        var lh = wurzel.querySelector("[data-laenge-hinweis]");
        if (lh) lh.hidden = zustand.laenge >= 2.5;
        var schieber = feld("laenge"), genau = feld("laengeExakt");
        if (name === "laengeExakt" && schieber) schieber.value = Math.min(zustand.laenge, 50);
        if (name === "laenge" && genau) genau.value = String(zustand.laenge).replace(".", ",");
      } else if (name === "hoehe") {
        zustand.hoehe = Number(e.value);
        if (zustand.hoehe < MIN_HOEHE_TORE) {
          // Keine Tore möglich: Frage zurück auf "Nein" stellen, Felder leeren.
          zustand.torEinzel = 0; zustand.torDoppel = 0; zustand.torJa = "nein";
          var torEinzelFeld2 = feld("torEinzel"); if (torEinzelFeld2) torEinzelFeld2.value = "";
          var torDoppelFeld2 = feld("torDoppel"); if (torDoppelFeld2) torDoppelFeld2.value = "";
          knopfgruppeAktualisieren();
        }
      } else if (name === "torEinzelBreite" || name === "torDoppelBreite") {
        zustand[name] = Number(e.value);
      } else {
        zustand[name] = Math.max(0, Math.floor(Number(e.value) || 0));
      }
      zeichnen();
    });

    function knopfgruppeAktualisieren() {
      wurzel.querySelectorAll("[data-wahl]").forEach(function (knopf) {
        var schluessel = knopf.getAttribute("data-wahl");
        var wert = knopf.getAttribute("data-wert");
        var aktiv = String(zustand[schluessel]) === wert;
        knopf.classList.toggle("active", aktiv);
        if (schluessel === "montage" && wert === "Aufdübeln") knopf.disabled = zustand.farbe === "Verzinkt";
        if (schluessel === "torSerie" && wert === "Basic") knopf.disabled = zustand.farbe === "Verzinkt";
      });
      // Torbreiten an die gewählte Serie anpassen
      ["single", "double"].forEach(function (typ) {
        var auswahl = feld(typ === "single" ? "torEinzelBreite" : "torDoppelBreite");
        if (!auswahl) return;
        var liste = TOR_BREITEN[(zustand.torSerie === "Multi" ? "multi_" : "basic_") + typ];
        var aktuell = typ === "single" ? zustand.torEinzelBreite : zustand.torDoppelBreite;
        if (liste.indexOf(aktuell) === -1) {
          aktuell = liste[0];
          if (typ === "single") zustand.torEinzelBreite = aktuell; else zustand.torDoppelBreite = aktuell;
        }
        auswahl.innerHTML = liste.map(function (b) {
          return '<option value="' + b + '"' + (b === aktuell ? " selected" : "") + ">" + (b / 10) + " cm</option>";
        }).join("");
      });
    }

    function bild(schluessel) { return (DATEN.bilder || {})[schluessel] || ""; }

    /* ---------- WhatsApp-Link mit der aktuellen Konfiguration füllen ---------- */
    var whatsappKnopf = wurzel.querySelector("[data-whatsapp]");
    var whatsappBasis = whatsappKnopf ? whatsappKnopf.getAttribute("href").split("?")[0] : "";
    function whatsappAktualisieren(r) {
      if (!whatsappKnopf) return;
      // Ohne gültige Stückliste bleibt der normale WhatsApp-Link stehen.
      if (!r.ok || !r.positionen || !r.positionen.length) {
        whatsappKnopf.setAttribute("href", whatsappBasis);
        return;
      }
      var zeilen = [
        "Hallo! Meine Zaun-Konfiguration aus dem Online-Konfigurator:",
        "Länge: " + zahl.format(zustand.laenge) + " m",
        "Höhe: " + zustand.hoehe + " mm",
        "Drahtstärke: " + zustand.staerke + " mm",
        "Farbe: " + zustand.farbe,
        "Pfosten: mit " + zustand.pfostenart,
        "Befestigung: " + zustand.montage
      ];
      if (zustand.ecken > 0) zeilen.push("Ecken: " + zustand.ecken);
      if (zustand.torEinzel > 0) zeilen.push("Einzeltore: " + zustand.torEinzel + "× " + (zustand.torEinzelBreite / 10) + " cm, Serie " + zustand.torSerie);
      if (zustand.torDoppel > 0) zeilen.push("Doppeltore: " + zustand.torDoppel + "× " + (zustand.torDoppelBreite / 10) + " cm, Serie " + zustand.torSerie);
      if (zustand.sichtAuto && r.sicht) zeilen.push("Sichtschutz: ja, " + zustand.sichtFarbe + " (" + r.sicht.text + ")");
      zeilen.push("Lieferung: " + zustand.lieferart);
      zeilen.push("Warenwert laut Konfigurator, ohne Lieferkosten: " + geld(r.warenwertCent));
      zeilen.push("Gesamt mit " + (zustand.lieferart === "Lieferung" ? "Lieferung" : "Abholung") + ": " + geld(r.warenwertCent + r.versandCent));
      whatsappKnopf.setAttribute("href", whatsappBasis + "?text=" + encodeURIComponent(zeilen.join("\n")));
    }

    /* ---------- Mobile Preisleiste ---------- */
    var leiste = wurzel.querySelector("[data-preisleiste]");
    var leisteWert = wurzel.querySelector("[data-preisleiste-wert]");
    var leisteText = wurzel.querySelector("[data-preisleiste-text]");
    var leisteKnopf = wurzel.querySelector("[data-preisleiste-knopf]");
    var leisteOk = false;
    if (leisteKnopf) {
      leisteKnopf.addEventListener("click", function () {
        // Zaunfluss 08.10.2026: direkt bestellen, sonst Stückliste zeigen.
        if (korbKnopf && !korbKnopf.disabled) { korbKnopf.click(); return; }
        var zielSummary = wurzel.querySelector(".package-summary");
        if (zielSummary) zielSummary.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }
    if (leiste && "IntersectionObserver" in window) {
      abschnittSichtbar = false;
      new IntersectionObserver(function (eintraege) {
        abschnittSichtbar = eintraege[0].isIntersecting;
        leisteZeigen();
      }).observe(wurzel);
    }
    function leisteAktualisieren(r) {
      leisteOk = !!(r.ok && r.positionen && r.positionen.length && r.warenwertCent > 0);
      if (leisteOk) {
        var eLeiste = endbetrag(r, zustand.lieferart);
        if (leisteWert) leisteWert.textContent = geld(eLeiste.gesamtCent);
        if (leisteText) leisteText.textContent = eLeiste.leisteText;
      }
      leisteZeigen();
    }
    function leisteZeigen() {
      if (!leiste) return;
      leiste.hidden = !(abschnittSichtbar && leisteOk && zustand.laenge > 0);
      document.body.classList.toggle("rz-preisleiste-an", !leiste.hidden);   /* blendet .mobile-sticky-cta aus (Umbau 08.10.2026) */
    }

    function zeichnen() {
      // Zaunfluss 08.10.2026: jeder Ausgang meldet das vorhandene Rechenergebnis.
      var r;
      try { r = berechne(zustand); zeichnenInnen(r); }
      finally { wurzel.dispatchEvent(new CustomEvent("zaun:gezeichnet", { detail: { zustand: zustand, ergebnis: r } })); }
    }
    function zeichnenInnen(r) {
      var ziel = wurzel.querySelector("[data-zusammenfassung]");
      var knopf = wurzel.querySelector("[data-in-den-korb]");
      var torBereich = wurzel.querySelector("[data-tor-bereich]");
      var torSperre = wurzel.querySelector("[data-tor-gesperrt]");

      if (torBereich && torSperre) {
        var toreMoeglich = zustand.hoehe >= MIN_HOEHE_TORE;
        torBereich.hidden = !toreMoeglich;
        torSperre.hidden = toreMoeglich;
        torSperre.textContent = "Bei einer Zaunhöhe von " + zustand.hoehe + " mm bieten wir keine Tore an. " +
          "Die kleinste lieferbare Torhöhe beträgt 800 mm, das Tor wäre damit höher als Ihr Zaun.";
      }

      // Ja/Nein-Fragen: Die Detail-Auswahl für Tor und Sichtschutz erscheint erst
      // nach "Ja" (Kevin 15.08.2026). Vorher ist nichts vorangeklickt sichtbar.
      var torDetails = wurzel.querySelector("[data-tor-details]");
      if (torDetails) torDetails.hidden = zustand.torJa !== "ja";
      var sichtDetails = wurzel.querySelector("[data-sicht-details]");
      if (sichtDetails) sichtDetails.hidden = zustand.sichtJa !== "ja";

      // "ab"-Preis am Tor-Ja-Knopf: günstigstes lieferbares Tor für die aktuelle
      // Zaunhöhe und Farbe, über beide Serien und alle Breiten hinweg.
      var torAb = wurzel.querySelector("[data-tor-abpreis]");
      if (torAb) {
        var torAbCent = Infinity;
        if (zustand.hoehe >= MIN_HOEHE_TORE) {
          var torAbHoehe = ZAUN_ZU_TOR_HOEHE[zustand.hoehe];
          ["Basic", "Multi"].forEach(function (serie) {
            if (serie === "Basic" && zustand.farbe === "Verzinkt") return;
            ["single", "double"].forEach(function (typ) {
              TOR_BREITEN[(serie === "Multi" ? "multi_" : "basic_") + typ].forEach(function (breite) {
                var torV = variante(skuTor(serie, typ, breite, torAbHoehe, zustand.farbe));
                if (torV && torV.preis < torAbCent) torAbCent = torV.preis;
              });
            });
          });
        }
        torAb.textContent = isFinite(torAbCent) ? "· ab + " + geld(torAbCent) : "";
      }

      // Produktbilder mitführen
      var bildZiel = wurzel.querySelector("[data-bilder]");
      if (bildZiel) {
        var gauge = zustand.staerke === "8/6/8" ? "868" : "656";
        var mattenBild = bild("fence-" + gauge + "-" + FARB_SLUG[zustand.farbe] + "-" + zustand.hoehe);
        var stuecke = [];
        if (mattenBild) stuecke.push('<figure><img src="' + mattenBild + '" alt="Doppelstabmatte ' + zustand.staerke + ' mm in ' + zustand.farbe + '" width="1000" height="750"><figcaption>Doppelstabmatte ' + zustand.staerke + ' · ' + zustand.farbe + "</figcaption></figure>");
        // Pfosten und Eckpfosten mit anzeigen - echte Einzelfotos in der
        // gewählten Farbe und Ausführung (Abdeckplättchen oder Abdeckleiste).
        var pfostenNormal = r.pfostenNormal || 0;
        var eckpfosten = r.eckpfosten || 0;
        var pfostenArtSlug = zustand.pfostenart === "Abdeckleiste" ? "leiste" : "plaettchen";
        var pfostenBild = bild("pfosten-" + pfostenArtSlug + "-" + FARB_SLUG[zustand.farbe]);
        var eckpfostenBild = bild("eckpfosten-" + pfostenArtSlug + "-" + FARB_SLUG[zustand.farbe]);
        if (pfostenNormal > 0 && pfostenBild) stuecke.push('<figure><img src="' + pfostenBild + '" alt="Zaunpfosten in ' + zustand.farbe + '" loading="lazy"><figcaption>' + pfostenNormal + "× Pfosten mit " + zustand.pfostenart + " · " + zustand.farbe + "</figcaption></figure>");
        if (eckpfosten > 0 && eckpfostenBild) stuecke.push('<figure><img src="' + eckpfostenBild + '" alt="Eckpfosten in ' + zustand.farbe + '" loading="lazy"><figcaption>' + eckpfosten + "× Eckpfosten mit " + zustand.pfostenart + " · " + zustand.farbe + "</figcaption></figure>");
        if (zustand.torEinzel > 0) stuecke.push('<figure><img src="' + bild("gate-" + zustand.torSerie.toLowerCase() + "-einzel") + '" alt="Einzeltor" loading="lazy"><figcaption>' + zustand.torEinzel + "× Einzeltor " + (zustand.torEinzelBreite / 10) + " cm</figcaption></figure>");
        if (zustand.torDoppel > 0) stuecke.push('<figure><img src="' + bild("gate-" + zustand.torSerie.toLowerCase() + "-doppel") + '" alt="Doppeltor" loading="lazy"><figcaption>' + zustand.torDoppel + "× Doppeltor " + (zustand.torDoppelBreite / 10) + " cm</figcaption></figure>");
        if (zustand.sichtAuto && r.sicht) {
          var sichtVorschau = bild("sicht-" + zustand.sichtForm.toLowerCase() + "-" + FARB_SLUG[zustand.sichtFarbe]);
          if (sichtVorschau) stuecke.push('<figure><img src="' + sichtVorschau + '" alt="Sichtschutzstreifen" loading="lazy"><figcaption>Sichtschutz ' + r.sicht.text + " · " + zustand.sichtFarbe + "</figcaption></figure>");
        }
        bildZiel.innerHTML = stuecke.join("");
      }
      var sichtBild = wurzel.querySelector("[data-sicht-bild]");
      if (sichtBild) sichtBild.src = bild("sicht-" + zustand.sichtForm.toLowerCase() + "-" + FARB_SLUG[zustand.sichtFarbe]);

      // Sichtschutz-Checkbox: Preis und Bedarf live anzeigen
      var sichtPreis = wurzel.querySelector("[data-sicht-preis]");
      var sichtBedarf = wurzel.querySelector("[data-sicht-bedarf]");
      if (sichtPreis) sichtPreis.textContent = r.sicht ? "+ " + geld(r.sicht.summeCent) : "";
      if (sichtBedarf) {
        if (r.sicht) {
          sichtBedarf.hidden = false;
          sichtBedarf.textContent = "Benötigt: " + zahl.format(r.sicht.bedarfMeter) + " m Streifen (" +
            r.sicht.reihen + " Reihen × " + r.matten + " Matten à 2,5 m) = " + r.sicht.text + ".";
        } else {
          sichtBedarf.hidden = true;
        }
      }

      // Aufpreis der Abdeckleiste je Pfosten, live aus den Shopify-Varianten
      var alAufpreis = wurzel.querySelector("[data-al-aufpreis]");
      if (alAufpreis) {
        var alV = variante(skuAbdeckleiste(zustand.hoehe, false));
        alAufpreis.textContent = alV ? "· + " + geld(alV.preis) + " je Pfosten" : "";
      }

      // Mehrpreis 8/6/8 gegenüber 6/5/6 für die aktuelle Konfiguration (Kevin
      // 09.08.2026): der Upsell zeigt den kleinen Aufpreis statt des Gesamtpreises.
      var staerkeAufpreis = wurzel.querySelector("[data-staerke-aufpreis]");
      if (staerkeAufpreis) {
        // Nur als Upsell anzeigen, solange 8/6/8 nicht ohnehin gewählt ist.
        var diffCent = 0;
        if (zustand.staerke !== "8/6/8") {
          var mit656 = berechne(Object.assign({}, zustand, { staerke: "6/5/6" }));
          var mit868 = berechne(Object.assign({}, zustand, { staerke: "8/6/8" }));
          diffCent = (mit656.ok && mit868.ok) ? mit868.warenwertCent - mit656.warenwertCent : 0;
        }
        staerkeAufpreis.textContent = diffCent > 0 ? "Nur + " + geld(diffCent) + " bei Ihrer Zaunlänge." : "";
      }

      // Sichtschutz „Ja“ bei 6/5/6: Hinweis mit Mehrpreis für genau diese Konfiguration
      // (Kundenrundgang Punkt 11). Der Knopf im Hinweis ist ein normaler data-wahl-Knopf und
      // läuft über den Klick-Handler oben. Keine Höhengrenze nennen.
      var sichtStaerkeHinweis = wurzel.querySelector("[data-sicht-staerke-hinweis]");
      if (sichtStaerkeHinweis) {
        var hinweisZeigen = zustand.sichtJa === "ja" && zustand.staerke === "6/5/6";
        sichtStaerkeHinweis.hidden = !hinweisZeigen;
        var mehrpreisFeld = sichtStaerkeHinweis.querySelector("[data-sicht-staerke-mehrpreis]");
        if (mehrpreisFeld && hinweisZeigen) {
          var ohne = berechne(Object.assign({}, zustand, { staerke: "6/5/6" }));
          var mit = berechne(Object.assign({}, zustand, { staerke: "8/6/8" }));
          var mehrCent = (ohne.ok && mit.ok) ? mit.warenwertCent - ohne.warenwertCent : 0;
          mehrpreisFeld.textContent = mehrCent > 0 ? "Mehrpreis bei Ihrer Zaunlänge: + " + geld(mehrCent) + " inkl. MwSt." : "";
        }
      }

      whatsappAktualisieren(r);
      leisteAktualisieren(r);

      // Fester Fußbereich der Zusammenfassung (Desktop): Gesamtpreis direkt über
      // "In den Warenkorb", damit ohne Scrollen bestellt werden kann.
      var fixZeile = wurzel.querySelector("[data-fixpreis]");
      var fixWert = wurzel.querySelector("[data-fixpreis-wert]");
      var fixOk = !!(r.ok && r.positionen && r.positionen.length && r.warenwertCent > 0);
      if (fixZeile) fixZeile.hidden = !fixOk;
      if (fixWert && fixOk) fixWert.textContent = geld(r.warenwertCent);
      if (fixOk) {
        var eFuss = endbetrag(r, zustand.lieferart);
        var fussText = wurzel.querySelector("[data-endbetrag-versand-text]");
        var fussVersand = wurzel.querySelector("[data-endbetrag-versand-wert]");
        var fussGesamt = wurzel.querySelector("[data-endbetrag-gesamt]");
        if (fussText) fussText.textContent = eFuss.versandText;
        if (fussVersand) fussVersand.textContent = "+ " + geld(eFuss.versandCent);
        if (fussGesamt) fussGesamt.textContent = geld(eFuss.gesamtCent);
      }

      if (!ziel) return;
      if (!r.ok && !r.positionen) {
        ziel.innerHTML = '<p class="korb-status fehler">' + r.meldung + "</p>";
        if (knopf) knopf.disabled = true;
        return;
      }

      var zeilen = r.positionen.map(function (p) {
        return "<tr><td><strong>" + p.titel + "</strong><small>" + p.details.join(" · ") + "</small></td>" +
          "<td>" + p.menge + "</td><td>" + geld(p.summeCent) + "</td></tr>";
      }).join("");

      var eSumme = endbetrag(r, zustand.lieferart);
      var stueckliste = "<p class=\"summary-label\">Ihr Komplettpaket</p><h3>" + zahl.format(zustand.laenge) + " m Doppelstabmattenzaun</h3>" +
        '<div class="parts"><div><strong>' + r.matten + "</strong><span>Matten à 2,5 m</span></div>" +
        "<div><strong>" + r.pfostenNormal + "</strong><span>Normale Pfosten</span></div>" +
        "<div><strong>" + r.eckpfosten + "</strong><span>Eckpfosten</span></div></div>" +
        '<div class="spec-line"><span>' + zustand.staerke + " mm</span><span>" + zustand.hoehe + " mm</span><span>" + zustand.farbe + "</span></div>" +
        '<table class="stueckliste-tabelle"><thead><tr><th>Position</th><th>Menge</th><th>Summe</th></tr></thead><tbody>' + zeilen + "</tbody></table>" +
        '<div class="price-breakdown endbetrag">' +
        '<div class="endbetrag-zeile"><span>Warenwert</span><span>' + geld(r.warenwertCent) + "</span></div>" +
        '<div class="endbetrag-zeile"><span>' + eSumme.versandText + "</span><span>+ " + geld(eSumme.versandCent) + "</span></div></div>" +
        '<div class="price-row"><span>Gesamt inkl. MwSt.</span><strong>' + geld(eSumme.gesamtCent) + "</strong></div>" +
        // Gratis-Beigabe nur, wenn wirklich Zaunfelder in der Stückliste stehen (Bericht Recht C4).
        (r.matten > 0 ? '<p class="gratis-hinweis">Gratis zu Ihrer Bestellung mit Doppelstabmatten: 1× Farbspraydose passend zur Zaunfarbe und 1× Inbusschlüssel 5,5 mm.</p>' : "") +
        '<p class="price-note">Alle Preise inklusive 19 % MwSt. ' +
        (zustand.lieferart === "Lieferung"
          ? (r.versandCent === 0 ? "Für dieses Paket ist die Lieferung deutschlandweit kostenlos (Warenwert ab " + rundGeld(VERSANDFREI_AB_CENT) + ")." : "Die Lieferung deutschlandweit kostet " + rundGeld(LIEFERKOSTEN_CENT) + " und ist oben eingerechnet, ab " + rundGeld(VERSANDFREI_AB_CENT) + " Warenwert ist sie kostenlos.")
          : "Bei Selbstabholung in Bremerhaven fallen keine Lieferkosten an.") +
        ' Verbindlich wählen Sie Lieferung oder Abholung im Kassenbereich. <a href="/pages/versand">Versand im Detail</a></p>';

      var hinweis = r.ok ? "" : '<p class="korb-status fehler">' + r.meldung +
        " Bitte fragen Sie uns direkt an, wir melden uns kurzfristig.</p>";

      ziel.innerHTML = stueckliste + hinweis;
      if (knopf) knopf.disabled = !r.ok || r.positionen.length === 0;
      wurzel.setAttribute("data-summe", r.warenwertCent);
    }

    // In den Warenkorb legen
    var korbKnopf = wurzel.querySelector("[data-in-den-korb]");
    if (korbKnopf) {
      korbKnopf.addEventListener("click", function () {
        var r = berechne(zustand);
        var meldungsFeld = wurzel.querySelector("[data-korb-meldung]");
        function melden(text, fehler) {
          if (!meldungsFeld) return;
          meldungsFeld.className = "korb-status" + (fehler ? " fehler" : "");
          meldungsFeld.innerHTML = text;
          meldungsFeld.hidden = false; // Zaunfluss 08.10.2026 (Inspektion F6): Leisten-Knopf ist jetzt Hauptweg, die Meldung muss sichtbar werden.
          if (fehler && leiste && !leiste.hidden) meldungsFeld.scrollIntoView({ block: "center" });
        }
        if (!r.ok || !r.positionen.length) { melden(r.meldung || "Bitte prüfen Sie die Konfiguration.", true); return; }

        korbKnopf.disabled = true;
        melden("Wird in den Warenkorb gelegt …", false);

        // Zaunfluss 08.10.2026: eine Kennung je Kauf für alle Teile.
        var zaunKennung = "Z" + Date.now().toString(36);
        var artikel = r.positionen.map(function (p) {
          return {
            id: p.id, quantity: p.menge,
            properties: {
              "_zaun": zaunKennung,
              "_zaun_text": zahl.format(zustand.laenge) + " m · " + zustand.hoehe + " mm · " + zustand.farbe,
              "Konfiguration": zahl.format(zustand.laenge) + " m · " + zustand.hoehe + " mm · " +
                zustand.staerke + " · " + zustand.farbe + " · " + zustand.montage,
              "Ausführung": p.details.join(" · "),
              "Gewünschte Lieferart": zustand.lieferart
            }
          };
        });

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ items: artikel })
        }).then(function (antwort) {
          return antwort.json().then(function (daten) {
            if (!antwort.ok) throw new Error(daten.description || daten.message || "Der Warenkorb hat die Positionen abgelehnt.");
            return daten;
          });
        }).then(function () {
          melden('Ihr Zaunpaket liegt im Warenkorb. <a href="/cart">Zum Warenkorb und zur Kasse →</a>', false);
          korbKnopf.disabled = false;
          // Mini-Warenkorb öffnen, damit der Kunde sofort sieht, was passiert ist.
          // Das Fenster holt den Korb selbst und setzt dabei auch den Zähler.
          if (window.RostKorb) window.RostKorb.oeffnen();
          else zaehlerAktualisieren();
        }).catch(function (fehler) {
          melden("Das hat nicht geklappt: " + fehler.message +
            ' Bitte melden Sie sich kurz bei uns, wir nehmen die Bestellung persönlich auf.', true);
          korbKnopf.disabled = false;
        });
      });
    }

    function zaehlerAktualisieren() {
      fetch("/cart.js", { headers: { "Accept": "application/json" } })
        .then(function (a) { return a.json(); })
        .then(function (korb) {
          document.querySelectorAll("[data-korb-zahl]").forEach(function (e) {
            e.textContent = korb.items.length;   /* Positionen, wie warenkorb.js (Umbau 08.10.2026) */
            e.hidden = korb.items.length === 0;
          });
        }).catch(function () { /* Zähler ist Beiwerk, Fehler bleibt ohne Folgen */ });
    }

    // Beispielpaket-Karten der Startseite: ein Klick übernimmt die Paket-Werte in
    // den Konfigurator (Kevin-Auftrag 10.08.2026, Prio 1.1). Die Karten liegen
    // außerhalb dieser Section, deshalb lauscht der Handler auf dem Dokument.
    // Der Ankersprung zu #konfigurator bleibt dem Browser überlassen.
    document.addEventListener("click", function (ereignis) {
      var karte = ereignis.target.closest("[data-paket-vorbelegen]");
      if (!karte) return;
      var d = karte.dataset;
      if (d.laenge) zustand.laenge = Number(d.laenge);
      if (d.hoehe) zustand.hoehe = Number(d.hoehe);
      if (d.staerke) zustand.staerke = d.staerke;
      if (d.farbe) zustand.farbe = d.farbe;
      if (d.pfostenart) zustand.pfostenart = d.pfostenart;
      if (d.montage) zustand.montage = d.montage;
      if (d.torSerie) zustand.torSerie = d.torSerie;
      zustand.torEinzel = Number(d.torEinzel) || 0;
      zustand.torDoppel = Number(d.torDoppel) || 0;
      if (d.torEinzelBreite) zustand.torEinzelBreite = Number(d.torEinzelBreite);
      zustand.ecken = 0;
      // PLB-Entwurf 30.09.2026: Anlass-Karte „Sichtschutz“ belegt auch den Sichtschutz vor (data-sicht="ja").
      // Alle anderen Karten schalten ihn wie bisher aus.
      var mitSicht = d.sicht === "ja";
      zustand.sichtAuto = mitSicht;
      zustand.sichtJa = mitSicht ? "ja" : "nein";
      if (mitSicht && d.farbe && d.farbe !== "Verzinkt") zustand.sichtFarbe = d.farbe;
      if (mitSicht && d.sichtForm) zustand.sichtForm = d.sichtForm;
      zustand.torJa = (zustand.torEinzel + zustand.torDoppel) > 0 ? "ja" : "nein";

      // Eingabefelder nachziehen, damit Anzeige und Zustand übereinstimmen.
      var schieber = feld("laenge"), genau = feld("laengeExakt"), hoehenwahl = feld("hoehe");
      if (schieber) schieber.value = Math.min(zustand.laenge, 50);
      if (genau) genau.value = String(zustand.laenge).replace(".", ",");
      if (hoehenwahl) hoehenwahl.value = String(zustand.hoehe);
      var einzelFeld = feld("torEinzel"); if (einzelFeld) einzelFeld.value = zustand.torEinzel || "";
      var doppelFeld = feld("torDoppel"); if (doppelFeld) doppelFeld.value = zustand.torDoppel || "";
      var eckenFeld = feld("ecken"); if (eckenFeld) eckenFeld.value = "";

      interagiert = true;
      knopfgruppeAktualisieren();
      zeichnen();
    });

    knopfgruppeAktualisieren();
    zeichnen();

    // PLB-Entwurf 30.09.2026: Beispielpreise der Anlass-Karten (sections/startseite-oben.liquid). Gerechnet wird mit
    // berechne(), also mit genau der Rechnung, die nach dem Klick im Konfigurator steht. Liefert die Rechnung keinen
    // Preis (fehlende Variante, fehlende Sichtschutz-Gebinde), bleibt die Preiszeile unsichtbar (Fail-Loud wie überall).
    // Steht bewusst NACH zeichnen() und in try/catch: ein Fehler hier darf den Konfigurator nie anhalten (Verifikator 30.09.2026).
    try { document.querySelectorAll("[data-anlass]").forEach(function (karte) {
      var knopf = karte.querySelector("[data-paket-vorbelegen]");
      var zeile = karte.querySelector("[data-anlass-preis]");
      var betrag = karte.querySelector("[data-anlass-betrag]");
      if (!knopf || !zeile || !betrag) return;
      var d = knopf.dataset;
      var mitSicht = d.sicht === "ja";
      var k = {
        laenge: Number(d.laenge), hoehe: Number(d.hoehe), staerke: d.staerke || "6/5/6", farbe: d.farbe || "Anthrazit",
        montage: d.montage || "Einbetonieren", ecken: 0, pfostenart: d.pfostenart || "Abdeckplättchen",
        torSerie: d.torSerie || "Basic", torEinzel: Number(d.torEinzel) || 0,
        torEinzelBreite: Number(d.torEinzelBreite) || 1000, torDoppel: Number(d.torDoppel) || 0, torDoppelBreite: 3000,
        lieferart: "Lieferung", sichtFarbe: d.farbe || "Anthrazit", sichtForm: d.sichtForm || "Genarbt", sichtAuto: mitSicht
      };
      var r = berechne(k);
      if (!r || !r.ok || !(r.warenwertCent > 0)) return;
      betrag.textContent = geld(r.warenwertCent);
      zeile.hidden = false;
    }); } catch (fehler) { /* Preiszeilen bleiben unsichtbar */ }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
